import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import langs from 'langs';

import { pipelineOptionFromEntity } from 'components/forms/autocomplete/Pipeline';
import { renderMailReplaceKeys } from 'helpers/mail';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import EmailPreview from 'components/layout/EmailPreview';

import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import FormLanguageSelector from 'components/forms/FormLanguageSelector';
import FormRichEditor from 'components/forms/FormRichEditor';

class LeadAutoresponseData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.state = {
      showLanguageSelection: false,
    };
  }

  showLanguageSelection = e => {
    e.preventDefault();
    this.setState({ showLanguageSelection: true });
  };

  render() {
    const {
      intl: { messages },
      projectConfig,
      entity,
      entityLoaded,
      disabled,
      inModal,
    } = this.props;
    const { showLanguageSelection } = this.state;

    return (
      <div class="clearfix">
        {entityLoaded && (
          <Row>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.formGroup.basic_information}</p>
                  <div class="form-group-attached">
                    <FormAutocomplete
                      label={messages.pipeline}
                      name="pipeline"
                      value={pipelineOptionFromEntity(entity.getPipeline())}
                      meta={entity.getPipelineMetaInformation()}
                      validation={entity.getPipelineValidationResult()}
                      onChange={this.updateEntity}
                      returnValueObject
                      autocompleteType="pipeline"
                      disabled={disabled}
                    />
                    {showLanguageSelection ? (
                      <FormLanguageSelector onChange={this.updateEntity} value={entity.getLang()} name="lang" />
                    ) : (
                      <div className="form-group form-group-default p-t-10 p-b-10">
                        <a href="#showLanguageSelection" className="text-master" onClick={this.showLanguageSelection}>
                          {messages.edit_language} ({langs.where('1', entity.getLang()).local}){' '}
                          <i className="fal fa-chevron-right m-l-10" />
                        </a>
                      </div>
                    )}
                    <FormInput
                      name="subject"
                      label={messages.subject}
                      value={entity.getSubject()}
                      meta={entity.getSubjectMetaInformation()}
                      validation={entity.getSubjectValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                    <FormRichEditor
                      name="content"
                      label={messages.content}
                      value={entity.getContent()}
                      meta={entity.getContentMetaInformation()}
                      validation={entity.getContentValidationResult()}
                      onChange={this.updateEntity}
                      disabled={disabled}
                    />
                  </div>

                  <div class="m-t-15">
                    <dl class="dl-horizontal no-margin">
                      <p>{messages.use_following_list_to_personalize_your_emails}</p>
                      {renderMailReplaceKeys(messages)}
                    </dl>
                  </div>
                </div>
              </div>
            </Col>

            {!inModal && (
              <Col xsHidden smHidden md={6} className={inModal ? 'hidden' : ''}>
                <div class="panel panel-transparent">
                  <div class="panel-body">
                    <p>{messages.preview}</p>
                    <EmailPreview content={entity.getContent()} projectConfig={projectConfig} />
                  </div>
                </div>
              </Col>
            )}
          </Row>
        )}
      </div>
    );
  }
}
LeadAutoresponseData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    projectConfig: state.data.projectConfig,
  };
};

export default injectIntl(connect(mapStateToProps)(LeadAutoresponseData));
